import React from 'react';

import ErrorMessage from 'components/ErrorMessage';
import Input from 'components/Input';
import { ENUM_SURVEY_TYPE, SURVEY_TYPES_WITH_PERIOD } from 'constants/enum';
import { LIST_SURVEY_TYPE, LIST_TYPE_SURVEY, LIST_TYPE_SURVEY_SDQ } from 'constants/index';
import { MESSAGE_CREATE_SURVEY } from 'constants/string/messages';
import { TEXT_CREATE_SURVEY } from 'constants/string/texts';
import useCreateSurvey from 'hooks/useCreateSurvey';

const SurveyTitle = (props) => {
  const { form, isEdit } = props;
  const { onSaveStep } = useCreateSurvey();

  const surveyType = form?.values?.survey_type || ENUM_SURVEY_TYPE.EXAM;
  // Only the exam questionnaire (health-checkup timing) and SDQ (age band) are
  // resolved by period; the other kinds have a single questionnaire per trial.
  const hasPeriodType = SURVEY_TYPES_WITH_PERIOD.includes(surveyType);
  const isSdq = surveyType === ENUM_SURVEY_TYPE.SDQ;

  const requiredIcon = <img className="mt-2" src={require('assets/resources/Required.svg').default} alt="required" width={7} height={7} />;

  const handleChangeSurveyType = (value) => {
    form.setFieldValue(['survey_type'], value);
    form.values.survey_type = value;

    // The period options differ per kind, so a period picked for the previous
    // kind would no longer be valid.
    form.setFieldValue(['period_type'], null);
    form.values.period_type = null;

    onSaveStep(form.values);
  };

  const handleChangePeriodType = (value) => {
    form.setFieldValue(['period_type'], value);
    form.values.period_type = value;
    onSaveStep(form.values);
  };

  return (
    <>
      <p className="text-black-102 pb-2 w-full flex items-start gap-1 break-all">
        {requiredIcon}
        {TEXT_CREATE_SURVEY.SURVEY_KIND}
      </p>
      <Input
        value={surveyType}
        onChange={handleChangeSurveyType}
        name="survey_type"
        list={LIST_SURVEY_TYPE}
        type="dropdown"
        placeholder={TEXT_CREATE_SURVEY.SURVEY_KIND_PLACEHOLDER}
        className="type-question-select"
        classNameInput="rounded-sm !text-black-102 !font-normal"
        classNameInputOption="rounded-lg !h-8 text-black opacity-85 !font-normal text-base"
        invalid={form?.errors?.survey_type}
      />

      {hasPeriodType && (
        <>
          <p className="text-black-102 pb-2 pt-4 w-full flex items-start gap-1 break-all">
            {requiredIcon}
            {isSdq ? TEXT_CREATE_SURVEY.SURVEY_PERIOD_SDQ : TEXT_CREATE_SURVEY.SURVEY_TYPE}
          </p>
          <Input
            value={form?.values?.period_type || null}
            onChange={handleChangePeriodType}
            name="period_type"
            list={isSdq ? LIST_TYPE_SURVEY_SDQ : LIST_TYPE_SURVEY}
            type="dropdown"
            placeholder={isSdq ? TEXT_CREATE_SURVEY.SURVEY_PERIOD_SDQ_PLACEHOLDER : '問診票の種類'}
            className="type-question-select"
            classNameInput="rounded-sm !text-black-102 !font-normal"
            classNameInputOption="rounded-lg !h-8 text-black opacity-85 !font-normal text-base"
            invalid={form?.errors?.period_type}
          />
          {form?.errors?.period_type && !isEdit && (
            <p className="text-sm text-danger-229 max-w-100">{<ErrorMessage>{MESSAGE_CREATE_SURVEY.SURVEY_SELECT_EMPTY}</ErrorMessage>}</p>
          )}
        </>
      )}
    </>
  );
};

export default React.memo(SurveyTitle);
